import { makeRequest } from "../utils/api";

export const getUsers = () => {
  return makeRequest(`/users/`, "GET");
};

export const getMe = () => {
  return makeRequest(`/users/me`, "GET");
};

export const updateMe =
  (setError) =>
  ({ first_name, last_name, email, phone_number }) => {
    return makeRequest(
      `/users/me`,
      "PUT",
      { first_name, last_name, email, phone_number },
      false,
      setError
    );
  };

export const changePassword =
  (setError) =>
  ({ password1, password2 }) => {
    return makeRequest(
      `/users/me/change-password`,
      "PUT",
      { password1, password2 },
      false,
      setError
    );
  };

export const updateUser = ({ id, is_verified }) => {
    return makeRequest(
      `/users/${id}`,
      "PUT",
      { is_verified }
    );
  };
